import { SeriesCell } from '@modules/Dashboard/Memberships/modules/Series/components/SeriesCell';
import React from 'react';
import * as S from './styled';
export const SeriesListItem = ({ series }) => {
    return (React.createElement(S.Container, null,
        React.createElement(SeriesCell, { title: series.title, quantity: series.episodesCount, thumbnailUrl: series.coverImage?.url })));
};
